import React from 'react';
import PropTypes from 'prop-types';
import styles from './TermSelector.scss';
import DefaultTermSettingsData from "./data/DefaultTermSettingsData";
import {useServicePriceContext} from "@contexts/ContextServicePriceProvider";
import {useScreenSizeBelowBreakpoint} from "@hooks/useScreenSizeBelowBreakpoint";

const TermSelector = ({data, selectedTerm, onChange, color = ''}) => {

	const settings = data ?? DefaultTermSettingsData;

	if (!settings.options.length) {
		return null;
	}

	const contextPrice = useServicePriceContext();
	const isLessThan460 = useScreenSizeBelowBreakpoint(460);

	return (
	  <div className={`${styles.termHolder} ${color ? styles[color] : ''}`}>
		  <div className={`${styles.termContainer}`}>
			  <div className={styles.textContainer}>
				  {settings.title}
			  </div>

			  <div className={styles.buttonContainer}>
				  {settings.options.map((option) => {

					  let biggerDiscount = 0;
					  if (option.discountServiceType) {
						  biggerDiscount = contextPrice.getBiggerDiscount(option.discountServiceType, option.id);
					  }

					  let discountText = '';
					  if (biggerDiscount > 0) {
						  discountText = '(' + option.discountText + '-' + biggerDiscount + '%)';
					  } else {
						  discountText = option.discountText ? `(${option.discountText})` : '';
					  }

					  return (
						<button
						  key={option.id}
						  type="button"
						  className={`${styles.termOption} ${selectedTerm === option.id ? styles.active : ''}`}
						  onClick={() => onChange(option.id)}>
							<span>
								{(isLessThan460 && option.labelShort) ? option.labelShort : option.label} {discountText}
							</span>
						</button>
					  );
				  })}
			  </div>
		  </div>
	  </div>
	);
};

TermSelector.propTypes = {
	data: PropTypes.object,
	selectedTerm: PropTypes.number.isRequired,
	onChange: PropTypes.func.isRequired,
	color: PropTypes.string
};

export default TermSelector;